import {
  AGE_DATE_RANGE_TOOLBOX_NAME,
  AGE_DATE_RANGE_TYPE,
  AGE_RANGE_YEAR_TOOLBOX_NAME,
  AGE_RANGE_YEAR_TYPE,
  ASSIGN_DRUG_KIT_TOOLBOX_NAME,
  ASSIGN_DRUG_KIT_TYPE,
  DISPENSE_DRUG_KIT_TOOLBOX_NAME,
  DISPENSE_DRUG_KIT_TYPE,
  DOB_AGE_SELECTOR_TOOLBOX_NAME,
  DOB_AGE_SELECTOR_TYPE,
  EQ5DL_TOOLBOX_NAME,
  EQ5DL_TYPE,
  GENDER_RADIO_TOOLBOX_NAME,
  GENDER_RADIO_TYPE,
  HEADER_TEXT_TOOLBOX_NAME,
  HEADER_TEXT_TYPE,
  NUMERIC_PAD_TOOLBOX_NAME,
  NUMERIC_PAD_TYPE,
  PARAGRAPH_TEXT_TOOLBOX_NAME,
  PARAGRAPH_TEXT_TYPE,
  PATIENT_VISIT_SELECTOR_TOOLBOX_NAME,
  PATIENT_VISIT_SELECTOR_TYPE,
  REPLACE_DRUG_KIT_TOOLBOX_NAME,
  REPLACE_DRUG_KIT_TYPE,
  SINGLE_CHECKBOX_TOOLBOX_NAME,
  SINGLE_CHECKBOX_TYPE,
  SINGLE_RADIO_TOOLBOX_NAME,
  SINGLE_RADIO_TYPE,
  SINGLE_SELECT_CHECKBOX_TOOLBOX_NAME,
  SINGLE_SELECT_CHECKBOX_TYPE,
  VAS_TOOLBOX_NAME,
  VAS_TYPE,
  VIDEO_PLAYER_TOOLBOX_NAME,
  VIDEO_PLAYER_TYPE,
  VISIT_DATE_PICKER_TOOLBOX_NAME,
  VISIT_DATE_PICKER_TYPE,
} from "./names";

export const addQuestionToToolBox = (creator) => {
  creator.toolbox.addItem({
    name: HEADER_TEXT_TOOLBOX_NAME,
    title: "Header Text",
    iconName: "custom-header-icon", // Use custom icon
    json: {
      type: HEADER_TEXT_TYPE,
      name: "header1",
      text: "<h3>Section Header</h3>",
      fontSize: "24px",
      fontWeight: "bold",
      alignment: "left",
    },
  });
  creator.toolbox.addItem({
    name: PARAGRAPH_TEXT_TOOLBOX_NAME,
    title: "Paragraph Text",
    iconName: "custom-para-icon",
    json: {
      type: PARAGRAPH_TEXT_TYPE,
      name: "paragraph1",
      content:
        "<p>This is a paragraph with formatting options. You can edit this text.</p>",
      fontSize: "16px",
      lineHeight: "1.6",
      padding: "15px",
    },
  });
  creator.toolbox.addItem({
    name: AGE_DATE_RANGE_TOOLBOX_NAME,
    title: "Age Date Range Picker",
    // NOTE: iconName is optional; using a known built-in icon improves UX.
    iconName: "age-date-range-icon",
    json: {
      type: AGE_DATE_RANGE_TYPE,
      title: "Age Date Range Picker",
      fromLabel: "From",
      toLabel: "To",
      minDate: "",
      maxDate: "",
    },
  });

  creator.toolbox.addItem({
    name: AGE_RANGE_YEAR_TOOLBOX_NAME,
    title: "Age Range Year",
    iconName: "age-range-year-icon",
    json: {
      type: AGE_RANGE_YEAR_TYPE,
      title: "Age Range Year",
      placeholder: "Age Year",
      step: 1,
    },
  });

  creator.toolbox.addItem({
    name: ASSIGN_DRUG_KIT_TOOLBOX_NAME,
    title: "Assigned Drug Kit Selector",
    iconName: "icon-expandfocused-16x16",
    json: {
      type: ASSIGN_DRUG_KIT_TYPE,
      title: "Assigned Drug Kit Selector",
    },
  });

  creator.toolbox.addItem({
    name: "cameraFile",
    title: "Camera",
    iconName: "icon-camera-32x32",
    json: {
      type: "file",
      name: "camera",
      title: "Camera",
      description: "Upload a file",
      allowMultiple: false,
      storeDataAsText: false,
    },
  });

  creator.toolbox.addItem({
    name: "dateInput",
    title: "Date",
    iconName: "custom-date-icon",
    json: {
      type: "text",
      name: "dateField",
      title: "Date",
      inputType: "date",
      placeholder: "Select date",
      // Additional date properties
      min: "",
      max: "",
      step: "",
      autocomplete: "off",
    },
  });

  creator.toolbox.addItem({
    name: "timeInput",
    title: "Time",
    iconName: "custom-time-icon",
    json: {
      type: "text",
      name: "timeField",
      title: "Time",
      inputType: "time",
      placeholder: "Select time",
      // Additional time properties
      min: "",
      max: "",
      step: "",
      autocomplete: "off",
    },
  });

  creator.toolbox.addItem({
    name: DISPENSE_DRUG_KIT_TOOLBOX_NAME,
    title: "Dispense Drug Kit",
    iconName: "icon-expandfocused-16x16",
    json: {
      type: DISPENSE_DRUG_KIT_TYPE,
      title: "Dispense Drug Kit",
    },
  });

  creator.toolbox.addItem({
    name: DOB_AGE_SELECTOR_TOOLBOX_NAME,
    title: "DOB Age Selector",
    iconName: "custom-age-selector-icon",
    json: {
      type: DOB_AGE_SELECTOR_TYPE,
      name: "age",
      title: "Age",
      placeholder: "Select Age",
      isRequired: false,
    },
  });

  creator.toolbox.addItem({
    name: EQ5DL_TOOLBOX_NAME,
    title: "EQ5D-5L",
    iconName: "custom-eq5dl-icon",
    json: {
      type: EQ5DL_TYPE,
      name: "eq5d5lDate",
      title: "EQ5D-5L Assessment",
      dateFormat: "yyyy-MM-dd",
      minDate: "",
      maxDate: "",
      showTodayButton: false,
    },
  });

  creator.toolbox.addItem({
    name: SINGLE_CHECKBOX_TOOLBOX_NAME,
    title: "Single Checkbox",
    iconName: "custom-single-checkbox-icon",
    json: {
      type: SINGLE_CHECKBOX_TYPE,
      name: "agreeCheckbox",
      title: "Checkbox",
      checkboxLabel: "",
      isRequired: false,
      defaultValue: false,
    },
  });

  creator.toolbox.addItem({
    name: NUMERIC_PAD_TOOLBOX_NAME,
    title: "Numeric Pad Input",
    iconName: "custom-numeric-pad-icon",
    json: {
      type: NUMERIC_PAD_TYPE,
      name: "numericInput",
      title: "Enter Number",
      placeholder: "Click to enter number",
      allowDecimal: true,
      allowNegative: false,
      maxLength: 10,
      numpadTheme: "light",
      showClearButton: true,
      showBackspaceButton: true,
    },
  });

  creator.toolbox.addItem({
    name: PATIENT_VISIT_SELECTOR_TOOLBOX_NAME,
    title: "Patient Visit Drug Kit Status",
    iconName: "custom-pateint-visit-icon",
    json: {
      type: PATIENT_VISIT_SELECTOR_TYPE,
      name: "drugKitStatus",
      title: "Drug Kit Status",
      placeholder: "Select or enter drug kit status",
      showStatusOptions: true,
      statusOptions: ["Active", "Dispensed", "Returned", "Expired", "Damaged"],
      allowCustomInput: true,
    },
  });

  creator.toolbox.addItem({
    name: SINGLE_RADIO_TOOLBOX_NAME,
    title: "Single Radio Button",
    iconName: "custom-radio-button-icon",
    json: {
      type: SINGLE_RADIO_TYPE,
      name: "consentRadio",
      title: "Consent",
      radioLabel: "I consent to participate",
      isRequired: false,
      defaultValue: false,
    },
  });

  creator.toolbox.addItem({
    name: GENDER_RADIO_TOOLBOX_NAME,
    title: "Radio Group",
    iconName: "custom-radio-group-icon",
    json: {
      type: GENDER_RADIO_TYPE,
      name: "gender",
      title: "Gender",
      genderQuestionLabel: "Gender",
      isRequired: false,
    },
  });

  creator.toolbox.addItem({
    name: REPLACE_DRUG_KIT_TOOLBOX_NAME,
    title: "Replace Drug Kit Selector",
    iconName: "custom-replace-drug-icon",
    json: {
      type: REPLACE_DRUG_KIT_TYPE,
      name: "replaceDrugKit",
      title: "Replace Drug Kit",
      placeholder: "Select replacement drug kit",
      choices: [], // Empty by default - users will add
    },
  });

  creator.toolbox.addItem({
    name: SINGLE_SELECT_CHECKBOX_TOOLBOX_NAME,
    title: "Single Select Checkbox",
    iconName: "custom-single-select-icon",
    json: {
      type: SINGLE_SELECT_CHECKBOX_TYPE,
      name: "singleSelect",
      title: "Single Select Checkbox",
      placeholder: "Select an option",
      choices: [], // Empty by default
    },
  });

  creator.toolbox.addItem({
    name: VAS_TOOLBOX_NAME,
    title: "VAS (Visual Analog Scale)",
    iconName: "custom-vas-icon", // Using SurveyJS built-in text icon
    json: {
      type: VAS_TYPE,
      name: "vas",
      title: "VAS Score",
      placeholder: "Enter VAS score",
      // maxLength: 3,
      isRequired: false,
    },
  });

  creator.toolbox.addItem({
    name: VIDEO_PLAYER_TOOLBOX_NAME,
    title: "Video URL",
    iconName: "custom-video-icon", // SurveyJS built-in video icon
    json: {
      type: VIDEO_PLAYER_TYPE,
      name: "video",
      title: "Video URL",
      placeholder: "Enter video URL",
      maxLength: 500,
      showPreview: false,
      inputType: "url",
    },
  });

  creator.toolbox.addItem({
    name: VISIT_DATE_PICKER_TOOLBOX_NAME,
    title: "Visit Date Picker",
    iconName: "custom-visit-date-picker-icon", // Use built-in date icon
    json: {
      type: VISIT_DATE_PICKER_TYPE,
      name: "visitDate",
      title: "Visit Date",
      placeholder: "Select visit date",
      minDate: "", // Can set default min date like "2024-01-01"
      maxDate: "", // Can set default max date like "2024-12-31"
    },
  });
};

export const filterQuestions = (creator) => {
  const ageDateRangeItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === AGE_DATE_RANGE_TYPE ||
      item.title === "Age Date Range Picker" ||
      item.name === AGE_DATE_RANGE_TYPE
    );
  });

  ageDateRangeItems.forEach((item) => {
    if (item.name === AGE_DATE_RANGE_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const ageRangeYearItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === AGE_RANGE_YEAR_TYPE ||
      item.title === "Age Range Year" ||
      item.name === AGE_RANGE_YEAR_TYPE
    );
  });

  ageRangeYearItems.forEach((item) => {
    if (item.name === AGE_RANGE_YEAR_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const assignedDrugKitItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === ASSIGN_DRUG_KIT_TYPE ||
      item.title === "Assigned Drug Kit Selector" ||
      item.name === ASSIGN_DRUG_KIT_TYPE
    );
  });

  assignedDrugKitItems.forEach((item) => {
    if (item.name === ASSIGN_DRUG_KIT_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const dispenseDrugKitItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === DISPENSE_DRUG_KIT_TYPE ||
      item.title === "Dispense Drug Kit" ||
      item.name === DISPENSE_DRUG_KIT_TYPE
    );
  });

  dispenseDrugKitItems.forEach((item) => {
    if (item.name === DISPENSE_DRUG_KIT_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const dobAgeSelectorItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === DOB_AGE_SELECTOR_TYPE ||
      item.title === "DOB Age Selector" ||
      item.name === DOB_AGE_SELECTOR_TYPE
    );
  });

  dobAgeSelectorItems.forEach((item) => {
    if (item.name === DOB_AGE_SELECTOR_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const eq5DlItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === EQ5DL_TYPE ||
      item.title === "EQ5D-5L Assessment" ||
      item.name === EQ5DL_TYPE
    );
  });

  eq5DlItems.forEach((item) => {
    if (item.name === EQ5DL_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const singleCheckboxItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === SINGLE_CHECKBOX_TYPE ||
      item.title === "Single Checkbox" ||
      item.name === SINGLE_CHECKBOX_TYPE
    );
  });

  singleCheckboxItems.forEach((item) => {
    if (item.name === SINGLE_CHECKBOX_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const numericPadItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === NUMERIC_PAD_TYPE ||
      item.title === "Numeric Pad Input" ||
      item.name === NUMERIC_PAD_TYPE
    );
  });

  numericPadItems.forEach((item) => {
    if (item.name === NUMERIC_PAD_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const patientVisitItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === PATIENT_VISIT_SELECTOR_TYPE ||
      item.title === "Patient Visit Drug Kit Status" ||
      item.name === PATIENT_VISIT_SELECTOR_TYPE
    );
  });

  patientVisitItems.forEach((item) => {
    if (item.name === PATIENT_VISIT_SELECTOR_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const singleRadioButtonItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === SINGLE_RADIO_TYPE ||
      item.title === "Single Radio Button" ||
      item.name === SINGLE_RADIO_TYPE
    );
  });

  singleRadioButtonItems.forEach((item) => {
    if (item.name === SINGLE_RADIO_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const groupRadioItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === GENDER_RADIO_TYPE ||
      item.title === "Radio Group" ||
      item.name === GENDER_RADIO_TYPE
    );
  });

  groupRadioItems.forEach((item) => {
    if (item.name === GENDER_RADIO_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  // Remove any duplicates
  const replaceDrugKitItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === REPLACE_DRUG_KIT_TYPE ||
      item.title === "Replace Drug Kit Selector" ||
      item.name === REPLACE_DRUG_KIT_TYPE
    );
  });

  replaceDrugKitItems.forEach((item) => {
    if (item.name === REPLACE_DRUG_KIT_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const singleSelectCheckboxItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === SINGLE_SELECT_CHECKBOX_TYPE ||
      item.title === "Single Select Checkbox" ||
      item.name === SINGLE_SELECT_CHECKBOX_TYPE
    );
  });

  singleSelectCheckboxItems.forEach((item) => {
    if (item.name === SINGLE_SELECT_CHECKBOX_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const vasItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === VAS_TYPE ||
      item.title === "VAS (Visual Analog Scale)" ||
      item.name === VAS_TYPE
    );
  });

  vasItems.forEach((item) => {
    if (item.name === VAS_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const videoPlayerItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === VIDEO_PLAYER_TYPE ||
      item.title === "Video URL" ||
      item.name === VIDEO_PLAYER_TYPE
    );
  });

  videoPlayerItems.forEach((item) => {
    if (item.name === VIDEO_PLAYER_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const visitDatePickerItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === VISIT_DATE_PICKER_TYPE ||
      item.title === "Visit Date Picker" ||
      item.name === VISIT_DATE_PICKER_TYPE
    );
  });

  visitDatePickerItems.forEach((item) => {
    if (item.name === VISIT_DATE_PICKER_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const headerTextItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === HEADER_TEXT_TYPE ||
      item.title === "Header Text" ||
      item.name === HEADER_TEXT_TYPE
    );
  });

  headerTextItems.forEach((item) => {
    if (item.name === HEADER_TEXT_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });

  const paragraphItems = creator.toolbox.items.filter((item) => {
    const itemType = item.json && item.json.type;
    return (
      itemType === PARAGRAPH_TEXT_TYPE ||
      item.title === "Paragraph Text" ||
      item.name === PARAGRAPH_TEXT_TOOLBOX_NAME
    );
  });

  paragraphItems.forEach((item) => {
    if (item.name === PARAGRAPH_TEXT_TOOLBOX_NAME) return;
    creator.toolbox.removeItem(item.name);
  });
};
